import { createStore, applyMiddleware } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import thunk from 'redux-thunk';
import { browserHistory } from 'react-router';
import { routerMiddleware  } from 'react-router-redux';
import reducer from './reducer';

const middlewares = [
	thunk,
	routerMiddleware(browserHistory)
];

// pass object to configure this, options like actionSanitizer, stateSanitizer
const composeEnhancers = composeWithDevTools;

const store = createStore(reducer, composeEnhancers(
	applyMiddleware(...middlewares)
));

if (process.env.NODE_ENV === 'development') {

	if (module.hot) {
		module.hot.accept('./reducer', () => store.replaceReducer(reducer));
	}
}

export default store;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/rocket/store.js